import * as moment from "moment";

export function GetStartOfHour(hour: number) {
    const startOfCurrentHourMoment = moment()
        .hour(hour)
        .minute(0)
        .second(0)
        .millisecond(0);

    const formattedEndTime = startOfCurrentHourMoment.format();
    return formattedEndTime;
}
